import { render, staticRenderFns } from "./Zitiddingdan.vue?vue&type=template&id=a56d9b30&"
import script from "./Zitiddingdan.vue?vue&type=script&lang=js&"
export * from "./Zitiddingdan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports